export const PROMO_CONSTANTS = {
    EMPLOYER_CTA_URL: 'https://www.indeed.com/hire?utm_source=jobseeker',
    VJ_CAMPAIGN: 'rn_vj',
    VJ_HOST_ID: 'jobsearch' as const,
    VJ_PAGE_ID: 'viewjob' as const,
};

/**
 * Relevant proctor test names for web to app promo
 * Add test names here when proctor tests are available
 * Related IQL indexes show only these tsts
 */
export const RELEVANT_TEST_NAMES: string[] = [
    'jsj_rn_mob_vj_offsite_w2a_promo_tst',
];
